

import * as React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { VerificationService, assertValidSegmentName, SegmentEnum } from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
}

const AcceptableUploadsComponent: React.SFC<Props> = ({ verificationService }) => {
    const segment = verificationService.verificationResponse.segment;
    assertValidSegmentName(segment);

    let acceptableUploads: JSX.Element;

    switch (segment) {
        case SegmentEnum.STUDENT:
            acceptableUploads =
                <ul className="sid-acceptable-uploads-list">
                    <li className="sid-acceptable-uploads-list__li">
                        <FormattedHTMLMessage
                            id="step.docUpload.acceptableUploads.student.idCard"
                            defaultMessage="School ID card with expiration date"
                        />
                    </li>
                    <li className="sid-acceptable-uploads-list__li">
                        <FormattedHTMLMessage
                            id="step.docUpload.acceptableUploads.student.classSchedule"
                            defaultMessage="Class schedule"
                        />
                    </li>
                    <li className="sid-acceptable-uploads-list__li">
                        <FormattedHTMLMessage
                            id="step.docUpload.acceptableUploads.student.tuitionReceipt"
                            defaultMessage="Tuition receipt"
                        />
                    </li>
                </ul>;
            break;
        default:
            return null;
    }

    return (
        <div>
            <span>
                <strong>
                    <FormattedMessage id="step.docUpload.acceptableUploadExamples" defaultMessage="Acceptable examples include:"/>
                </strong>
            </span>
            {acceptableUploads}
        </div>
    );
};

export { AcceptableUploadsComponent };
